import React from "react";
import MiniHeaders from "./mini-headers";
import ImageCarousel from "./image-carousel";

function getOpinionImageNameList(){
    const list = [];
    for (let i = 1; i < 26; i++) {
        list.push(`opinion-image-${i}`)
    }
    return list;
}

const Opinion = () => {
    return (
        <div>
            <div className={'wrapper blocks-wrapper'}>
                <MiniHeaders headerName={'Կարծիքներ'}/>
                <div>
                    <ImageCarousel items={getOpinionImageNameList()}/>
                </div>
            </div>
        </div>
    );
};

export default Opinion;
